import { render, staticRenderFns } from "./LessonMaterial.vue?vue&type=template&id=0a0bd172&scoped=true&"
import script from "./LessonMaterial.vue?vue&type=script&lang=js&"
export * from "./LessonMaterial.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0bd172",
  null
  
)

export default component.exports